export default __webpack_public_path__ + "d4ba77f18c3e77e006ffd942ef364d69.jpg";